import { Decision } from '@/interfaces/decision';
import { EntityResource } from './entity.resource';

/**
 * Resource decyzji
 *
 * @export
 * @class DecisionResource
 * @extends {EntityResource<Decision>}
 */
export class DecisionResource extends EntityResource<Decision> {
  public getFields = {
    id: true,
    name: true
  };

  public listFields = {
    id: true,
    name: true,
    number: true,
    data: true,
    startDate: true,
    endDate: true,
    document: {
      id: true,
      systemNumbers: true
    }
  };

  constructor() {
    super({
      entityName: 'decision'
    });
  }
}

export const decisionResource = new DecisionResource();
